import _ from "lodash";
import { getUserInfofromStorage } from "services/localStorage";
import { store } from "store/createStore";
import { showGlobalHeaderInLibrary } from "./ACLStoreUtils";
import {
  DUMMY_USER_INFO,
  PUBLIC_USER_INFO_AP_SOUTH_EAST_1,
  PUBLIC_USER_INFO_AP_SOUTH_EAST_2,
  PUBLIC_USER_INFO_EU_WEST_1,
  PUBLIC_USER_INFO_ME_CENTRAL_1,
  PUBLIC_USER_INFO_US_EAST_1,
  PUBLIC_USER_INFO_EU_CENTRAL_1,
} from "Constants";
import {
  isLibraryResourceRoute,
  isPublicPlatformRoute,
  isToddleLibraryRoute,
} from "./RouteMatchUtils";

const getUserInfoMemo = _.memoize(
  ({ portalUserInfo, userInfo, portalType, userIdentityDetails }) => {
    return {
      ...(portalUserInfo || userInfo || {}),
      portalType,
      userIdentityDetails,
    };
  },
  ({ portalUserInfo, userInfo, portalType, userIdentityDetails }) => {
    const id = _.get(portalUserInfo, "id", _.get(userInfo, "id", ""));
    const type = _.get(
      portalUserInfo,
      "user_type",
      _.get(userInfo, "user_type", "")
    );
    const org_id = _.get(userInfo, "org_id", "COMMUNITY");
    const token = _.get(userInfo, "token", "");
    const tags = _.get(userInfo, "tags", _.get(portalUserInfo, "tags", []));
    const role = _.get(userInfo, "role", _.get(portalUserInfo, "role", ""));
    const childID = _.get(userInfo, "childID", "");
    const isChildBlocked = _.get(userInfo, "isChildBlocked", false);
    const childBlockedMessage = _.get(userInfo, "childBlockedMessage", "");
    const isDevUser = _.get(userInfo, "isDevUser", "");
    const userEntityType = _.get(userInfo, "userEntityType", "");
    const orgPlan = _.get(userInfo, "orgPlan", "");
    const region = _.get(userInfo, "region", "");
    const projectGroups = _.get(userInfo, "projectGroups", "");
    const userCurriculumProgramIds = _.map(
      _.get(userInfo, "userCurriculumPrograms", []),
      "id"
    );
    const idpCode = _.get(userInfo, "idpCode", "");

    return JSON.stringify({
      id,
      type,
      org_id,
      portalType,
      tags,
      role,
      userIdentityDetails,
      childID,
      isDevUser,
      userEntityType,
      orgPlan,
      region,
      projectGroups,
      isChildBlocked,
      childBlockedMessage,
      token,
      userCurriculumProgramIds,
      idpCode,
    });
  }
);

export const getUserInfo = ({ portalType } = {}) => {
  const state = store.getState();
  const userInfo = _.get(state, "login.userInfo") ?? getUserInfofromStorage();
  const publicToken = _.get(state, "login.publicToken");
  const userIdentityDetails = _.get(state, "login.userIdentityDetails", []);
  let portalUserInfo = null;

  if (isToddleLibraryRoute()) {
    /**
     * - If portal type is not passed and is a library resource route (LE/Unit/Worksheet/Question), set portalType to "COMMUNITY".
     * - The permission check "showGlobalHeaderInLibrary()" is for old behavior
     *   where portalType "COMMUNITY" is passed in all the library queries if portalType is undefined
     */
    const setCommunityPortalType =
      !portalType && (!showGlobalHeaderInLibrary() || isLibraryResourceRoute());

    if (setCommunityPortalType) {
      portalType = "COMMUNITY";
    }
    if (_.isEmpty(userInfo)) {
      portalUserInfo = {
        ...DUMMY_USER_INFO,
        token: publicToken,
        jwt: publicToken,
      };
    }
  }

  if (isPublicPlatformRoute()) {
    return `Bearer ${publicToken}`;
  }

  //Handled only for staff. Because userIdentityDetails is not exposed for student
  if (
    !!portalType &&
    _.isEmpty(portalUserInfo) &&
    userInfo.user_type == "staff"
  ) {
    portalUserInfo = _.find(
      userIdentityDetails,
      item => item.portalType == portalType
    );
    if (!_.isEmpty(portalUserInfo) && !_.has(portalUserInfo, ["user_type"])) {
      portalUserInfo["user_type"] = "staff";
      portalUserInfo["userEntityType"] = "STAFF";
    }

    if (!_.isEmpty(portalUserInfo) && userInfo?.idpCode) {
      portalUserInfo["idpCode"] = userInfo.idpCode;
    }
  }

  return getUserInfoMemo({
    portalUserInfo,
    userInfo,
    portalType,
    userIdentityDetails,
  });
};

export const fetchOrganizationAndUserIdForPublicPost = () => {
  const query = new URLSearchParams(window.location.search);
  switch (query.get("region")) {
    case "us-east-1":
      return {
        organizationId: PUBLIC_USER_INFO_US_EAST_1.org_id,
        userId: PUBLIC_USER_INFO_US_EAST_1.id,
      };
    case "ap-southeast-2":
      return {
        organizationId: PUBLIC_USER_INFO_AP_SOUTH_EAST_2.org_id,
        userId: PUBLIC_USER_INFO_AP_SOUTH_EAST_2.id,
      };
    case "ap-southeast-1":
      return {
        organizationId: PUBLIC_USER_INFO_AP_SOUTH_EAST_1.org_id,
        userId: PUBLIC_USER_INFO_AP_SOUTH_EAST_1.id,
      };
    case "me-central-1":
      return {
        organizationId: PUBLIC_USER_INFO_ME_CENTRAL_1.org_id,
        userId: PUBLIC_USER_INFO_ME_CENTRAL_1.id,
      };
    case "eu-central-1":
      return {
        organizationId: PUBLIC_USER_INFO_EU_CENTRAL_1.org_id,
        userId: PUBLIC_USER_INFO_EU_CENTRAL_1.id,
      };
    default:
      return {
        organizationId: PUBLIC_USER_INFO_EU_WEST_1.org_id,
        userId: PUBLIC_USER_INFO_EU_WEST_1.id,
      };
  }
};
